import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const PREBID_STACK_FRAGMENT: TypedDocumentNode<AbTestsParametersSchemaDTO['prebidStack']> =
  gql`
    fragment prebidStackFragment on AbTestsParametersPrebidStack {
      auctionDelay {
        label
      }
      domainAmazonEnabled {
        label
      }
      label
      monetizeNonConsentTraffic {
        label
      }
      prebidStackEnabled {
        label
      }
      prebidTimeout {
        label
      }

      bidders {
        label
        items {
          id
          label
        }
      }

      prebidModules {
        label
        analytics {
          label
          items {
            id
            label
          }
        }
        general {
          label
          items {
            id
            label
          }
        }
        userId {
          label
          items {
            id
            label
          }
        }
        vendorSpecific {
          label
          items {
            id
            label
          }
        }
      }
    }
  `
